import { component } from 'picoapp';

export default component(async (node) => {
  const initCookieBtnTrigger = () => {
    const observer = new IntersectionObserver(([entry]) => {
      const cookieBtn = document.querySelector('#Coi-Renew');
      cookieBtn?.classList[entry.isIntersecting ? 'add' : 'remove']('!opacity-100', '!pointer-events-auto');
    });

    observer.observe(node);
  };

  const init = () => {
    initCookieBtnTrigger();
  };

  init();
});
